module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO34PresupuestoMensualGastosOcasionales.4bdcde2.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO34PresupuestoMensualGastosOcasionales.mp4
// module id = 760
// module chunks = 1